<template>
	<div :style="styles" class="link-echarts"></div>
</template>

<script>
export default {
	name: "link-echarts",
	props: {
		option: {type: [Object, Function]},
		width: {type: [String, Number]},
		height: {type: [String, Number], default: '300'},
	},
	data() {
		return {
			getCurrentEchartInstance: () => null,
		}
	},
	watch: {
		option: {
			immediate: true,
			async handler() {
				await this.$lv.nextTick()
				await this.reset()
			},
		},
	},
	computed: {
		styles() {
			const {width, height} = this
			const styles = {}
			if (width != null) {styles.width = this.$lv.$utils.unit(width)}
			if (height != null) {styles.height = this.$lv.$utils.unit(height)}
			return styles
		},
	},
	methods: {
		async reset() {
			if (!this.option) {
				return
			}
			const echarts = await this.$lv.resource.loadLib('echarts')
			let ins = this.getCurrentEchartInstance()
			if (!ins) {
				ins = echarts.init(this.$el)
				this.getCurrentEchartInstance = () => ins
			} else {
				ins.clear()
			}
			const opt = typeof this.option === "function" ? this.option({echarts}) : this.option
			ins.setOption(opt)
		},
	},
	beforeDestroy() {
		const ins = this.getCurrentEchartInstance()
		if (!!ins) {
			ins.dispose()
			this.getCurrentEchartInstance = () => null
		}
	},
}
</script>

<style lang="scss">

</style>